import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34bccc3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "references" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "dark-blue" }, "Références", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Classées par ordre alphabétique du premier auteur :", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Andersen B, Christensen BS, Christensen J, Serizawa R, Viborg PH, Waldstrom M, et al. HPV-prevalence in elderly women in Denmark. Gynecol Oncol 2019 Jul;154(1):118-123.", -1))
const _hoisted_5 = {
  key: 0,
  href: "https://www.gynecologiconcology-online.net/article/S0090-8258(19)31182-5/fulltext",
  target: "blank"
}
const _hoisted_6 = {
  key: 1,
  href: "medics://viewer?m_source=https://www.gynecologiconcology-online.net/article/S0090-8258(19)31182-5/fulltext"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Arbyn M, Verdoodt F, Snijders PJ, Verhoef VM, Suonio E, Dillner L, et al. Accuracy of human papillomavirus testing on self-collected versus clinician-collected samples: a meta-analysis. Lancet Oncol 2014;15(2):172-83.", -1))
const _hoisted_8 = {
  key: 2,
  href: "https://www.floqs.ru/files/publications/Accuracy-of-HPV-meta-analysis.pdf",
  target: "blank"
}
const _hoisted_9 = {
  key: 3,
  href: "medics://viewer?m_source=https://www.floqs.ru/files/publications/Accuracy-of-HPV-meta-analysis.pdf"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Arbyn M, Ronco G, Anttila A, Meijer CJ, Poljak M, Ogilvie G, et al. Evidence regarding human papillomavirus testing in secondary prevention of cervical cancer. Vaccine 2012;30(Suppl 5):F88-99.", -1))
const _hoisted_11 = {
  key: 4,
  href: "https://pubmed.ncbi.nlm.nih.gov/23199969/",
  target: "blank"
}
const _hoisted_12 = {
  key: 5,
  href: "medics://viewer?m_source=https://pubmed.ncbi.nlm.nih.gov/23199969/"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Belgian Health Care Knowledge Centre, Arbyn M, Haelens A, Desomer A, Verdoodt F, Thiry N, et al. Cervical cancer screening program and human papillomavirus (HPV) testing, part II: update on HPV primary screening. KCE reports 238. Brussels: KCE; 2015.", -1))
const _hoisted_14 = {
  key: 6,
  href: "https://kce.fgov.be/sites/default/files/atoms/files/KCE__238_HPV_DNA_Testing_Report2_.pdf",
  target: "blank"
}
const _hoisted_15 = {
  key: 7,
  href: "medics://viewer?m_source=https://kce.fgov.be/sites/default/files/atoms/files/KCE__238_HPV_DNA_Testing_Report2_.pdf"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Canfell K, Caruana M, Gebski V, Darlington-Brown J, Heley S, Brotherton J, et al. Cervical screening with primary HPV testing or cytology in a population of women in which those aged 33 years or younger had previously been offered HPV vaccination: results of the Compass pilot randomised trial. PLoS Med 2017;14(9):e1002388.", -1))
const _hoisted_17 = {
  key: 8,
  href: "https://journals.plos.org/plosmedicine/article?id=10.1371/journal.pmed.1002388",
  target: "blank"
}
const _hoisted_18 = {
  key: 9,
  href: "medics://viewer?m_source=https://journals.plos.org/plosmedicine/article?id=10.1371/journal.pmed.1002388"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Canfell K, Saville M, Caruana M, Gebski V, Darlington-Brown J, Brotherton J, et al. Protocol for Compass: a randomised controlled trial of primary HPV testing versus cytology screening for cervical cancer in HPV-unvaccinated and vaccinated women aged 25-69 years living in Australia. BMJ Open 2018;8(1):e016700.", -1))
const _hoisted_20 = {
  key: 10,
  href: "https://www.compasstrial.org.au/wp-content/uploads/2020/06/Compass-Main_Protocol-V1.8_CLEAN.pdf",
  target: "blank"
}
const _hoisted_21 = {
  key: 11,
  href: "medics://viewer?m_source=https://www.compasstrial.org.au/wp-content/uploads/2020/06/Compass-Main_Protocol-V1.8_CLEAN.pdf"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Castle P, Stoler M, Wright T, Sharma A,Wright T, Behrens C. Performance of carcinogenic human papillomavirus (HPV) testing and HPV16 or HPV18 genotyping for cervical cancer screening of women aged 25 years and older: a subanalysis of the ATHENA study. Lancet Oncol. 2011 Sep;12(9):880-90.", -1))
const _hoisted_23 = {
  key: 12,
  href: "https://pubmed.ncbi.nlm.nih.gov/21865084/",
  target: "blank"
}
const _hoisted_24 = {
  key: 13,
  href: "medics://viewer?m_source=https://pubmed.ncbi.nlm.nih.gov/21865084/"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Chen HC, Schiffman M, Lin CY, Pan MH, You SL, Chuang LC, et al. Persistence of type-specific human papillomavirus infection and increased long-term risk of cervical cancer. J Natl Cancer Inst. 2011;103(18):1387–1396.", -1))
const _hoisted_26 = {
  key: 14,
  href: "https://academic.oup.com/jnci/article/103/18/1387/2568888",
  target: "blank"
}
const _hoisted_27 = {
  key: 15,
  href: "medics://viewer?m_source=https://academic.oup.com/jnci/article/103/18/1387/2568888"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "de Kok IM, van Rosmalen J, Dillner J, Arbyn M, Sasieni P, Iftner T, et al. Primary screening for human papillomavirus compared with cytology screening for cervical cancer in European settings: cost effectiveness analysis based on a Dutch microsimulation model. BMJ 2012;344:e670.", -1))
const _hoisted_29 = {
  key: 16,
  href: "https://portal.research.lu.se/portal/files/1520491/2539843.pdf",
  target: "blank"
}
const _hoisted_30 = {
  key: 17,
  href: "medics://viewer?m_source=https://portal.research.lu.se/portal/files/1520491/2539843.pdf"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Dijkstra M, Van Zummeren M, Rozendaal L, Van Kemenade F, Helmerhorst T, Snijders P, et al. Safety of extending screening intervals beyond five years in cervical screening programmes with testing for high risk human papillomavirus: 14 year follow-up of population based randomised cohort in the Netherlands. BMJ. 2016;", -1))
const _hoisted_32 = {
  key: 18,
  href: "https://www.bmj.com/content/355/bmj.i4924",
  target: "blank"
}
const _hoisted_33 = {
  key: 19,
  href: "medics://viewer?m_source=https://www.bmj.com/content/355/bmj.i4924"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Dillner J, Rebolj M, Birembaut P, Petry KU, Szarewski A, Munk C, et al. Long term predictive values of cytology and human papillomavirus testing in cervical cancer screening: Joint European cohort study. BMJ. 2008;337(7676):969–972.", -1))
const _hoisted_35 = {
  key: 20,
  href: "https://www.jstor.org/stable/20511136?seq=1",
  target: "blank"
}
const _hoisted_36 = {
  key: 21,
  href: "medics://viewer?m_source=https://www.jstor.org/stable/20511136?seq=1"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Feldman S, Cook E, David M, Gershman ST, Hanchate A, Haas JS, Perkins RB, et al. Cervical Cancer Incidence Among Elderly Women in Massachusetts Compared With Younger Women. J Low Genit Tract Dis 2018 Oct;22(4):314-317.", -1))
const _hoisted_38 = {
  key: 22,
  href: "https://journals.lww.com/jlgtd/Abstract/2018/10000/Cervical_Cancer_Incidence_Among_Elderly_Women_in.9.aspx",
  target: "blank"
}
const _hoisted_39 = {
  key: 23,
  href: "medics://viewer?m_source=https://journals.lww.com/jlgtd/Abstract/2018/10000/Cervical_Cancer_Incidence_Among_Elderly_Women_in.9.aspx"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Gage J, Hunt W, Schiffman M, Katki H, Cheung Li, Cuzick J, et al. Risk Stratification using Human Papillomavirus Testing among Women with Equivocally Abnormal Cytology: Results from a State-wide Surveillance Program. Cancer Epidemiol Biomarkers Prev. 2016 January; 25 (1):36-42", -1))
const _hoisted_41 = {
  key: 24,
  href: "https://pubmed.ncbi.nlm.nih.gov/26518316/",
  target: "blank"
}
const _hoisted_42 = {
  key: 25,
  href: "medics://viewer?m_source=https://pubmed.ncbi.nlm.nih.gov/26518316/"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Gage JC, Schiffman M, Katki HA, Castle PE, Fetterman B, Wentzensen N, et al. Reassurance against future risk of precancer and cancer conferred by a negative human papillomavirus test. J Natl Cancer Inst 2014;106(8):dju153.", -1))
const _hoisted_44 = {
  key: 26,
  href: "https://academic.oup.com/jnci/article/107/1/dju369/903691",
  target: "blank"
}
const _hoisted_45 = {
  key: 27,
  href: "medics://viewer?m_source=https://academic.oup.com/jnci/article/107/1/dju369/903691"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Gravitt PE, Landy R, Schiffman M, et al. How confident can we be in the current guidelines for exiting cervical screening? Prev Med 2018 Sep;114:188-194.", -1))
const _hoisted_47 = {
  key: 28,
  href: "https://www.sciencedirect.com/science/article/abs/pii/S0091743518302123?via%3Dihub",
  target: "blank"
}
const _hoisted_48 = {
  key: 29,
  href: "medics://viewer?m_source=https://www.sciencedirect.com/science/article/abs/pii/S0091743518302123?via%3Dihub"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Hall MT, Simms KT, Lew JB, Smith MA, Saville M, Canfell K. Projected future impact of HPV vaccination and primary HPV screening on cervical cancer rates from 2017-2035: example from Australia. PLoS One 2018;13(2):e0185332.", -1))
const _hoisted_50 = {
  key: 30,
  href: "https://pdfs.semanticscholar.org/29db/38d63e79d4473f286f8c58ec9d75fabb7257.pdf?_ga=2.168993186.280986.1617889996-1024467435.1617889996",
  target: "blank"
}
const _hoisted_51 = {
  key: 31,
  href: "medics://viewer?m_source=https://pdfs.semanticscholar.org/29db/38d63e79d4473f286f8c58ec9d75fabb7257.pdf?_ga=2.168993186.280986.1617889996-1024467435.1617889996"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Hamers F, Poullié AI, Arbyn M. Updated evidence-based recommendations for cervical cancer screening in France. European Journal of Cancer Prevention. 2021 Jul 8.", -1))
const _hoisted_53 = {
  key: 32,
  href: "https://journals.lww.com/eurjcancerprev/Abstract/9000/Updated_evidence_based_recommendations_for.99034.aspx",
  target: "blank"
}
const _hoisted_54 = {
  key: 33,
  href: "medics://viewer?m_source=https://journals.lww.com/eurjcancerprev/Abstract/9000/Updated_evidence_based_recommendations_for.99034.aspx"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Hermansson RS, Olovsson M, Hoxell E, Lindström AK, et al. HPV prevalence and HPV-related dysplasia in elderly women. PLoS One 2018 Jan 10;13(1).", -1))
const _hoisted_56 = {
  key: 34,
  href: "https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0189300",
  target: "blank"
}
const _hoisted_57 = {
  key: 35,
  href: "medics://viewer?m_source=https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0189300"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Katki HA, Kinney WK, Fetterman B, Lorey T, Poitras NE, Cheung L, et al. Cervical cancer risk for women undergoing concurrent testing for human papillomavirus and cervical cytology: a population-based study in routine clinical practice. Lancet Oncol. 2011 Jul;12(7):663–672. Epub 2011 Jun 16. Erratum in: Lancet Oncol 2011;12(8):722. PubMed PMID: 21684207", -1))
const _hoisted_59 = {
  key: 36,
  href: "https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(11)70145-0/fulltext",
  target: "blank"
}
const _hoisted_60 = {
  key: 37,
  href: "medics://viewer?m_source=https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(11)70145-0/fulltext"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Khan MJ, Massad LS, Kinney W, Gold MA, Mayeaux Jr EJ, Darragh TM, Castle PE, Chelmow D, Lawson HW, Huh WK, et al. A common clinical dilemma: Management of abnormal vaginal cytology and human papillomavirus test results. Gynecol Oncol 2016 May;141(2):364-370.", -1))
const _hoisted_62 = {
  key: 38,
  href: "https://www.gynecologiconcology-online.net/article/S0090-8258(15)30195-5/fulltext",
  target: "blank"
}
const _hoisted_63 = {
  key: 39,
  href: "medics://viewer?m_source=https://www.gynecologiconcology-online.net/article/S0090-8258(15)30195-5/fulltext"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Kitchener HC, Almonte M, Thomson C, Wheeler P, Sargent A, Stoykova B, et al. HPV testing in combination with liquid-based cytology in primary cervical screening (ARTISTIC): a randomised controlled trial. Lancet Oncol 2009;10(7):672-82.", -1))
const _hoisted_65 = {
  key: 40,
  href: "https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(09)70156-1/fulltext",
  target: "blank"
}
const _hoisted_66 = {
  key: 41,
  href: "medics://viewer?m_source=https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(09)70156-1/fulltext"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Kjaer SK, Frederiksen K, Munk C, Iftner T. Long-term absolute risk of cervical intraepithelial neoplasia grade 3 or worse following human papillomavirus infection: role of persistence. J Natl Cancer Inst. 2010;102(19):1478–1488.", -1))
const _hoisted_68 = {
  key: 42,
  href: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2950170/",
  target: "blank"
}
const _hoisted_69 = {
  key: 43,
  href: "medics://viewer?m_source=https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2950170/"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Lannér L, Lindström AK, et al. Incidence of HPV and HPV related dysplasia in elderly women in Sweden. PLoS One 2020 Mar 20,15(3)", -1))
const _hoisted_71 = {
  key: 44,
  href: "https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0229758",
  target: "blank"
}
const _hoisted_72 = {
  key: 45,
  href: "medics://viewer?m_source=https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0229758"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Lei J, Bengt A, Ploner A, Lagheden C, Eklund C, Nordqvist S, et al. Cervical screening and risk of adenosquamous and rare histological types of invasive cervical carcinoma: population based nested case-control study. BMJ. 2019;365:l1207", -1))
const _hoisted_74 = {
  key: 46,
  href: "https://doi.org/10.1136/bmj.l1207",
  target: "blank"
}
const _hoisted_75 = {
  key: 47,
  href: "medics://viewer?m_source=https://doi.org/10.1136/bmj.l1207"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Leinonen M, Nieminen P, Kotaniemi-Talonen L, Malila N, Tarkkanen J, Laurila P, et al. Age-specific evaluation of primary human papillomavirus screening vs conventional cytology in a randomized setting. J Natl Cancer Inst 2009;101(23):1612-23.", -1))
const _hoisted_77 = {
  key: 48,
  href: "https://academic.oup.com/jnci/article/101/23/1612/2515674",
  target: "blank"
}
const _hoisted_78 = {
  key: 49,
  href: "medics://viewer?m_source=https://academic.oup.com/jnci/article/101/23/1612/2515674"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Malagón T, Kulasingham S, Mayrand M-H, et al. Age at last screening and remaining lifetime risk of cervical cancer in older, unvaccinated women: a modelling study. Lancet Oncol 2018; 19: 1569–78.", -1))
const _hoisted_80 = {
  key: 50,
  href: "https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(18)30536-9/fulltext",
  target: "blank"
}
const _hoisted_81 = {
  key: 51,
  href: "medics://viewer?m_source=https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(18)30536-9/fulltext"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Mayrand MH, Duarte-Franco E, Rodrigues I, Walter SD, Hanley J, Ferenczy A, et al. Human papillomavirus DNA versus Papanicolaou screening tests for cervical cancer. N Engl J Med 2007;357(16):1579-88.", -1))
const _hoisted_83 = {
  key: 52,
  href: "https://www.isdmguatemala.org/wp-content/uploads/2019/08/Human-Papillomavirus-DNA-versus-Papanicolaou-Screening-Tests-for-Cervical-Cancer.pdf",
  target: "blank"
}
const _hoisted_84 = {
  key: 53,
  href: "medics://viewer?m_source=https://www.isdmguatemala.org/wp-content/uploads/2019/08/Human-Papillomavirus-DNA-versus-Papanicolaou-Screening-Tests-for-Cervical-Cancer.pdf"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Monsonego J, Hudgens MG, Zerat L, Zerat JC, Syrjänen K, Smith JS, et al. Risk assessment and clinical impact of liquid-based cytology, oncogenic human papillomavirus (HPV) DNA and mRNA testing in primary cervical cancer screening (The FASE Study). Gynecology Oncology 2012;125(1):175-80", -1))
const _hoisted_86 = {
  key: 54,
  href: "https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_9389795c4ae24722b096a7f66224189d.pdf",
  target: "blank"
}
const _hoisted_87 = {
  key: 55,
  href: "medics://viewer?m_source=https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_9389795c4ae24722b096a7f66224189d.pdf"
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Monsonego J, Zerat L, Syrjänen K, Zerat JC, Smith JS, Halfon P, et al. Prevalence of type-specific human papillomavirus infection among women in France: Implications for screening, vaccination, and a future generation of multivalent HPV vaccines. Vaccine 2012;30(35):5215-21", -1))
const _hoisted_89 = {
  key: 56,
  href: "https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_b013a9e7f2674850bc7fed5fad8003a3.pdf",
  target: "blank"
}
const _hoisted_90 = {
  key: 57,
  href: "medics://viewer?m_source=https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_b013a9e7f2674850bc7fed5fad8003a3.pdf"
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Monsonego J, Hudgens MG, Zerat L, Zerat JC, Syrjänen K, Halfon P, Ruiz F, Smith JS, et al. Evaluation of oncogenic human papillomavirus RNA and DNA tests with liquid-based cytology in primary cervical cancer screening: the FASE study. Int. J. Cancer 2011;129(3):691-701", -1))
const _hoisted_92 = {
  key: 58,
  href: "https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_bd01b6ddd528472ea430571264e497d3.pdf",
  target: "blank"
}
const _hoisted_93 = {
  key: 59,
  href: "medics://viewer?m_source=https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_bd01b6ddd528472ea430571264e497d3.pdf"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Monsonego J, Cox JT, Behrens C, Sandri M, Frnaco EL, Yap PS, Huh W, et al. Prevalence of high-risk human papilloma virus genotypes and associated risk of cervical precancerous lesions in a large U.S. screening populations: Data from ATHENA trial. Gynecologic Oncology 2015;137(1)47-54", -1))
const _hoisted_95 = {
  key: 60,
  href: "https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_1c3886578eb24f70859479141713521d.pdf",
  target: "blank"
}
const _hoisted_96 = {
  key: 61,
  href: "medics://viewer?m_source=https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_1c3886578eb24f70859479141713521d.pdf"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Monsonego J, Zerat L, Syrjänen K, Zerat J-C, Smith JS, Halfon P, et al. Prevalence of type-specific human papillomavirus infection among women in France: Implications for screening, vaccination, and a future generation of multivalent HPV vaccines. Vaccine 30 (2012) 5215-5221.", -1))
const _hoisted_98 = {
  key: 62,
  href: "https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_b013a9e7f2674850bc7fed5fad8003a3.pdf",
  target: "blank"
}
const _hoisted_99 = {
  key: 63,
  href: "medics://viewer?m_source=https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_b013a9e7f2674850bc7fed5fad8003a3.pdf"
}
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Moscicki AB, Flowers L, Huchko M, Long ME, MacLaughlin KL, Murphy J, Spiryda LB, Gold MA, et al. Guidelines for Cervical Cancer Screening in Immunosuppressed Women Without HIV Infection. J Low Genit Tract Dis 2019 Apr;23(2):87-101", -1))
const _hoisted_101 = {
  key: 64,
  href: "https://journals.lww.com/jlgtd/Abstract/2019/04000/Guidelines_for_Cervical_Cancer_Screening_in.1.aspx",
  target: "blank"
}
const _hoisted_102 = {
  key: 65,
  href: "medics://viewer?m_source=https://journals.lww.com/jlgtd/Abstract/2019/04000/Guidelines_for_Cervical_Cancer_Screening_in.1.aspx"
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Naucler P, Ryd W, Törnberg S, Strand A, Wadell G, Elfgren K, et al. Efficacy of HPV DNA Testing with cytology triage and/or Repeat HPV DNA Testing in Primary Cervica Cancer Screening. J Natl Cancer Inst. 2009 Jan 21;101(2):88-99.", -1))
const _hoisted_104 = {
  key: 66,
  href: "10.1093/jnci/djn444",
  target: "blank"
}
const _hoisted_105 = {
  key: 67,
  href: "medics://viewer?m_source=10.1093/jnci/djn444"
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Naucler P, Ryd W, Tornberg S, Strand A, Wadell G, Elfgren K, et al. Human papillomavirus and Papanicolaou tests to screen for cervical cancer. N Engl J Med 2007;357(16):1589-97.", -1))
const _hoisted_107 = {
  key: 68,
  href: "https://www.nejm.org/doi/full/10.1056/NEJMoa073204",
  target: "blank"
}
const _hoisted_108 = {
  key: 69,
  href: "medics://viewer?m_source=https://www.nejm.org/doi/full/10.1056/NEJMoa073204"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Nielsen A, Iftner T, Munk C, Kjaer SK, et al. Acquisition of high-risk human papillomavirus infection in a population-based cohort of Danish women. Sex Transm Dis 2019 Oct;36(10):609-15.", -1))
const _hoisted_110 = {
  key: 70,
  href: "https://journals.lww.com/stdjournal/Fulltext/2009/10000/Acquisition_of_High_Risk_Human_Papillomavirus.4.aspx",
  target: "blank"
}
const _hoisted_111 = {
  key: 71,
  href: "medics://viewer?m_source=https://journals.lww.com/stdjournal/Fulltext/2009/10000/Acquisition_of_High_Risk_Human_Papillomavirus.4.aspx"
}
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ogilvie GS, Krajden M, van Niekerk DJ, Martin RE, Ehlen TG, Ceballos K, et al. Primary cervical cancer screening with HPV testing compared with liquid-based cytology: results of round 1 of a randomised controlled trial: the HPV FOCAL study. Br J Cancer 2012;107(12):1917-24.", -1))
const _hoisted_113 = {
  key: 72,
  href: "https://www.nature.com/articles/bjc2012489",
  target: "blank"
}
const _hoisted_114 = {
  key: 73,
  href: "medics://viewer?m_source=https://www.nature.com/articles/bjc2012489"
}
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ogilvie GS, van Niekerk D, Krajden M, Smith LW, Cook D, Gondara L, et al. Effect of screening with primary cervical hpv testing vs cytology testing on high-grade cervical intraepithelial neoplasia at 48 months: the HPV focal randomized clinical trial. JAMA 2018;320(1):43-52.", -1))
const _hoisted_116 = {
  key: 74,
  href: "https://jamanetwork.com/journals/jama/fullarticle/2686793",
  target: "blank"
}
const _hoisted_117 = {
  key: 75,
  href: "medics://viewer?m_source=https://jamanetwork.com/journals/jama/fullarticle/2686793"
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Philip E. Castle, PhD, MPH; Walter K. Kinney, MD*; Xiaonan Xue, PhD, et al. Effect of Several Negative Rounds of Human Papillomavirus and Cytology Co-testing on Safety Against Cervical Cancer - An Observational Cohort Study. Ann Intern Med. 2018 Jan 2;168(1):20-29.", -1))
const _hoisted_119 = {
  key: 76,
  href: "https://pubmed.ncbi.nlm.nih.gov/29181509/",
  target: "blank"
}
const _hoisted_120 = {
  key: 77,
  href: "medics://viewer?m_source=https://pubmed.ncbi.nlm.nih.gov/29181509/"
}
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Rebolj M, Bonde J, Preisler S, Ejegod D, Rygaard C, Lynge E. Human Papillomavirus Assays and Cytology in Primary Cervical Screening of Women Aged 30 Years and Above. PLoS One. 2016 Jan 20;11(1)", -1))
const _hoisted_122 = {
  key: 78,
  href: "https://pubmed.ncbi.nlm.nih.gov/26789267/",
  target: "blank"
}
const _hoisted_123 = {
  key: 79,
  href: "medics://viewer?m_source=https://pubmed.ncbi.nlm.nih.gov/26789267/"
}
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Rijkaart DC, Berkhof J, Rozendaal L, van Kemenade FJ, Bulkmans NW, Heideman DA, et al. Human papillomavirus testing for the detection of high-grade cervical intraepithelial neoplasia and cancer: final results of the POBASCAM randomised controlled trial. Lancet Oncol 2012;13(1):78-88.", -1))
const _hoisted_125 = {
  key: 80,
  href: "https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(11)70296-0/fulltext",
  target: "blank"
}
const _hoisted_126 = {
  key: 81,
  href: "medics://viewer?m_source=https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(11)70296-0/fulltext"
}
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ronco G, Dillner J, Elfström KM, Tunesi S, Snijders PJ, Arbyn M, et al. Efficacy of HPV-based screening for prevention of invasive cervical cancer: follow-up of four European randomised controlled trials. Lancet 2014;383(9916):524-32.", -1))
const _hoisted_128 = {
  key: 82,
  href: "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(13)62218-7/fulltext",
  target: "blank"
}
const _hoisted_129 = {
  key: 83,
  href: "medics://viewer?m_source=https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(13)62218-7/fulltext"
}
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ronco G, Biggeri A, Confortini M, Giorgi Rossi P, Naldoni C, Segnan N, et al. Health Technology Assessment. Ricerca del DNA di papillomavirus umano (HPV) come test primario per lo screening dei precursori del cancro del collo uterino. Epidemiol Prev 2012;36(3-4 Suppl 1):e1-72.", -1))
const _hoisted_131 = {
  key: 84,
  href: "https://www.epiprev.it/pubblicazione/epidemiol-prev-2012-36-3-4-suppl-1",
  target: "blank"
}
const _hoisted_132 = {
  key: 85,
  href: "medics://viewer?m_source=https://www.epiprev.it/pubblicazione/epidemiol-prev-2012-36-3-4-suppl-1"
}
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ronco G, Segnan N, Giorgi-Rossi P, Zappa M, Casadei GP, Carozzi F, et al. Human papillomavirus testing and liquid-based cytology: results at recruitment from the new technologies for cervical cancer randomized controlled trial. J Natl Cancer Inst 2006;98(11):765-74.", -1))
const _hoisted_134 = {
  key: 86,
  href: "https://academic.oup.com/jnci/article/98/11/765/2521604",
  target: "blank"
}
const _hoisted_135 = {
  key: 87,
  href: "medics://viewer?m_source=https://academic.oup.com/jnci/article/98/11/765/2521604"
}
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ronco G, Giorgi-Rossi P, Carozzi F, Confortini M, Dalla Palma P, del Mistro A, et al. Efficacy of human papillomavirus testing for the detection of invasive cervical cancers and cervical intraepithelial neoplasia: a randomised controlled trial. Lancet Oncol 2010;11(3):249-57.", -1))
const _hoisted_137 = {
  key: 88,
  href: "https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(09)70360-2/fulltext",
  target: "blank"
}
const _hoisted_138 = {
  key: 89,
  href: "medics://viewer?m_source=https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(09)70360-2/fulltext"
}
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ronco G, Zappa M, Franceschi S, Tunesi S, Caprioglio A, Confortini M, et al. Impact of variations in triage cytology interpretation on human -papillomavirus-based cervical screening and implications for screening algorithms. European Journal of Cancer. 68 (2016) 148e155", -1))
const _hoisted_140 = {
  key: 90,
  href: "https://www.ejcancer.com/article/S0959-8049(16)32429-7/fulltext",
  target: "blank"
}
const _hoisted_141 = {
  key: 91,
  href: "medics://viewer?m_source=https://www.ejcancer.com/article/S0959-8049(16)32429-7/fulltext"
}
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Rosenblatt KA, Osterbur EF, Douglas JA, et al. Case-control study of cervical cancer and gynecologic screening: A SEER-Medicare analysis. Gynecol Oncol 2016Sep;142(3):395-400.", -1))
const _hoisted_143 = {
  key: 92,
  href: "https://www.gynecologiconcology-online.net/article/S0090-8258(16)30827-7/fulltext",
  target: "blank"
}
const _hoisted_144 = {
  key: 93,
  href: "medics://viewer?m_source=https://www.gynecologiconcology-online.net/article/S0090-8258(16)30827-7/fulltext"
}
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Sankaranarayanan R, Nene BM, Shastri SS, Jayant K, Muwonge R, Budukh AM, et al. HPV screening for cervical cancer in rural India. N Engl J Med 2009;360(14):1385-94.", -1))
const _hoisted_146 = {
  key: 94,
  href: "http://archive.azcentral.com/ic/pdf/new-england-journal-medicine.pdf",
  target: "blank"
}
const _hoisted_147 = {
  key: 95,
  href: "medics://viewer?m_source=http://archive.azcentral.com/ic/pdf/new-england-journal-medicine.pdf"
}
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Schiffman M, Glass AG, Wentzensen N, Rush BB, Castle PE, Scott DR, et al. A long-term prospective study of type-specific human papillomavirus infection and risk of cervical neoplasia among 20,000 women in the Portland Kaiser Cohort Study. Cancer Epidemiol Biomarkers Prev. 2011;20(7):1398–1409.", -1))
const _hoisted_149 = {
  key: 96,
  href: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3156084/",
  target: "blank"
}
const _hoisted_150 = {
  key: 97,
  href: "medics://viewer?m_source=https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3156084/"
}
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Strander B, Andersson-Ellström A, Milsom I, Sparén P, et al. Long term risk of invasive cancer after treatment for cervical intraepithelial neoplasia grade 3: population based cohort study. BMJ 2007 Nov 24;335(7629):1077.", -1))
const _hoisted_152 = {
  key: 98,
  href: "https://www.bmj.com/content/335/7629/1077.long",
  target: "blank"
}
const _hoisted_153 = {
  key: 99,
  href: "medics://viewer?m_source=https://www.bmj.com/content/335/7629/1077.long"
}
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Velentzis L, Caruana M, Simms K, Lew JB, Shi JF, Saville M, et al. How will transitioning from cytology to HPV testing change the balance between the benefits and harms of cervical cancer screening? Int J Cancer. 2017 Dec 15;141(12):2410-2422.", -1))
const _hoisted_155 = {
  key: 100,
  href: "https://pubmed.ncbi.nlm.nih.gov/28801947/",
  target: "blank"
}
const _hoisted_156 = {
  key: 101,
  href: "medics://viewer?m_source=https://pubmed.ncbi.nlm.nih.gov/28801947/"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_5, "https://www.gynecologiconcology-online.net/article/S0090-8258(19)31182-5/fulltext"))
      : (_openBlock(), _createElementBlock("a", _hoisted_6, "https://www.gynecologiconcology-online.net/article/S0090-8258(19)31182-5/fulltext")),
    _hoisted_7,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_8, "https://www.floqs.ru/files/publications/Accuracy-of-HPV-meta-analysis.pdf"))
      : (_openBlock(), _createElementBlock("a", _hoisted_9, "https://www.floqs.ru/files/publications/Accuracy-of-HPV-meta-analysis.pdf")),
    _hoisted_10,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_11, "https://pubmed.ncbi.nlm.nih.gov/23199969/"))
      : (_openBlock(), _createElementBlock("a", _hoisted_12, "https://pubmed.ncbi.nlm.nih.gov/23199969/")),
    _hoisted_13,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_14, "https://kce.fgov.be/sites/default/files/atoms/files/KCE__238_HPV_DNA_Testing_Report2_.pdf"))
      : (_openBlock(), _createElementBlock("a", _hoisted_15, "https://kce.fgov.be/sites/default/files/atoms/files/KCE__238_HPV_DNA_Testing_Report2_.pdf")),
    _hoisted_16,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_17, "https://journals.plos.org/plosmedicine/article?id=10.1371/journal.pmed.1002388"))
      : (_openBlock(), _createElementBlock("a", _hoisted_18, "https://journals.plos.org/plosmedicine/article?id=10.1371/journal.pmed.1002388")),
    _hoisted_19,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_20, "https://www.compasstrial.org.au/wp-content/uploads/2020/06/Compass-Main_Protocol-V1.8_CLEAN.pdf"))
      : (_openBlock(), _createElementBlock("a", _hoisted_21, "https://www.compasstrial.org.au/wp-content/uploads/2020/06/Compass-Main_Protocol-V1.8_CLEAN.pdf")),
    _hoisted_22,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_23, "https://pubmed.ncbi.nlm.nih.gov/21865084/"))
      : (_openBlock(), _createElementBlock("a", _hoisted_24, "https://pubmed.ncbi.nlm.nih.gov/21865084/")),
    _hoisted_25,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_26, "https://academic.oup.com/jnci/article/103/18/1387/2568888"))
      : (_openBlock(), _createElementBlock("a", _hoisted_27, "https://academic.oup.com/jnci/article/103/18/1387/2568888")),
    _hoisted_28,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_29, "https://portal.research.lu.se/portal/files/1520491/2539843.pdf"))
      : (_openBlock(), _createElementBlock("a", _hoisted_30, "https://portal.research.lu.se/portal/files/1520491/2539843.pdf")),
    _hoisted_31,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_32, "https://www.bmj.com/content/355/bmj.i4924"))
      : (_openBlock(), _createElementBlock("a", _hoisted_33, "https://www.bmj.com/content/355/bmj.i4924")),
    _hoisted_34,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_35, "https://www.jstor.org/stable/20511136?seq=1"))
      : (_openBlock(), _createElementBlock("a", _hoisted_36, "https://www.jstor.org/stable/20511136?seq=1")),
    _hoisted_37,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_38, "https://journals.lww.com/jlgtd/Abstract/2018/10000/Cervical_Cancer_Incidence_Among_Elderly_Women_in.9.aspx"))
      : (_openBlock(), _createElementBlock("a", _hoisted_39, "https://journals.lww.com/jlgtd/Abstract/2018/10000/Cervical_Cancer_Incidence_Among_Elderly_Women_in.9.aspx")),
    _hoisted_40,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_41, "https://pubmed.ncbi.nlm.nih.gov/26518316/"))
      : (_openBlock(), _createElementBlock("a", _hoisted_42, "https://pubmed.ncbi.nlm.nih.gov/26518316/")),
    _hoisted_43,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_44, "https://academic.oup.com/jnci/article/107/1/dju369/903691"))
      : (_openBlock(), _createElementBlock("a", _hoisted_45, "https://academic.oup.com/jnci/article/107/1/dju369/903691")),
    _hoisted_46,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_47, "https://www.sciencedirect.com/science/article/abs/pii/S0091743518302123?via%3Dihub"))
      : (_openBlock(), _createElementBlock("a", _hoisted_48, "https://www.sciencedirect.com/science/article/abs/pii/S0091743518302123?via%3Dihub")),
    _hoisted_49,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_50, "https://pdfs.semanticscholar.org/29db/38d63e79d4473f286f8c58ec9d75fabb7257.pdf?_ga=2.168993186.280986.1617889996-1024467435.1617889996"))
      : (_openBlock(), _createElementBlock("a", _hoisted_51, "https://pdfs.semanticscholar.org/29db/38d63e79d4473f286f8c58ec9d75fabb7257.pdf?_ga=2.168993186.280986.1617889996-1024467435.1617889996")),
    _hoisted_52,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_53, "https://journals.lww.com/eurjcancerprev/Abstract/9000/Updated_evidence_based_recommendations_for.99034.aspx"))
      : (_openBlock(), _createElementBlock("a", _hoisted_54, "https://journals.lww.com/eurjcancerprev/Abstract/9000/Updated_evidence_based_recommendations_for.99034.aspx")),
    _hoisted_55,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_56, "https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0189300"))
      : (_openBlock(), _createElementBlock("a", _hoisted_57, "https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0189300")),
    _hoisted_58,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_59, "https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(11)70145-0/fulltext"))
      : (_openBlock(), _createElementBlock("a", _hoisted_60, "https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(11)70145-0/fulltext")),
    _hoisted_61,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_62, "https://www.gynecologiconcology-online.net/article/S0090-8258(15)30195-5/fulltext"))
      : (_openBlock(), _createElementBlock("a", _hoisted_63, "https://www.gynecologiconcology-online.net/article/S0090-8258(15)30195-5/fulltext")),
    _hoisted_64,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_65, "https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(09)70156-1/fulltext"))
      : (_openBlock(), _createElementBlock("a", _hoisted_66, "https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(09)70156-1/fulltext")),
    _hoisted_67,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_68, "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2950170/"))
      : (_openBlock(), _createElementBlock("a", _hoisted_69, "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2950170/")),
    _hoisted_70,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_71, "https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0229758"))
      : (_openBlock(), _createElementBlock("a", _hoisted_72, "https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0229758")),
    _hoisted_73,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_74, "https://doi.org/10.1136/bmj.l1207"))
      : (_openBlock(), _createElementBlock("a", _hoisted_75, "https://doi.org/10.1136/bmj.l1207")),
    _hoisted_76,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_77, "https://academic.oup.com/jnci/article/101/23/1612/2515674"))
      : (_openBlock(), _createElementBlock("a", _hoisted_78, "https://academic.oup.com/jnci/article/101/23/1612/2515674")),
    _hoisted_79,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_80, "https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(18)30536-9/fulltext"))
      : (_openBlock(), _createElementBlock("a", _hoisted_81, "https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(18)30536-9/fulltext")),
    _hoisted_82,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_83, "https://www.isdmguatemala.org/wp-content/uploads/2019/08/Human-Papillomavirus-DNA-versus-Papanicolaou-Screening-Tests-for-Cervical-Cancer.pdf"))
      : (_openBlock(), _createElementBlock("a", _hoisted_84, "https://www.isdmguatemala.org/wp-content/uploads/2019/08/Human-Papillomavirus-DNA-versus-Papanicolaou-Screening-Tests-for-Cervical-Cancer.pdf")),
    _hoisted_85,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_86, "https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_9389795c4ae24722b096a7f66224189d.pdf"))
      : (_openBlock(), _createElementBlock("a", _hoisted_87, "https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_9389795c4ae24722b096a7f66224189d.pdf")),
    _hoisted_88,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_89, "https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_b013a9e7f2674850bc7fed5fad8003a3.pdf"))
      : (_openBlock(), _createElementBlock("a", _hoisted_90, "https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_b013a9e7f2674850bc7fed5fad8003a3.pdf")),
    _hoisted_91,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_92, "https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_bd01b6ddd528472ea430571264e497d3.pdf"))
      : (_openBlock(), _createElementBlock("a", _hoisted_93, "https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_bd01b6ddd528472ea430571264e497d3.pdf")),
    _hoisted_94,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_95, "https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_1c3886578eb24f70859479141713521d.pdf"))
      : (_openBlock(), _createElementBlock("a", _hoisted_96, "https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_1c3886578eb24f70859479141713521d.pdf")),
    _hoisted_97,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_98, "https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_b013a9e7f2674850bc7fed5fad8003a3.pdf"))
      : (_openBlock(), _createElementBlock("a", _hoisted_99, "https://f758b61a-d1d9-4520-84a0-f58ec97c77b4.filesusr.com/ugd/47895b_b013a9e7f2674850bc7fed5fad8003a3.pdf")),
    _hoisted_100,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_101, "https://journals.lww.com/jlgtd/Abstract/2019/04000/Guidelines_for_Cervical_Cancer_Screening_in.1.aspx"))
      : (_openBlock(), _createElementBlock("a", _hoisted_102, "https://journals.lww.com/jlgtd/Abstract/2019/04000/Guidelines_for_Cervical_Cancer_Screening_in.1.aspx")),
    _hoisted_103,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_104, "10.1093/jnci/djn444"))
      : (_openBlock(), _createElementBlock("a", _hoisted_105, "10.1093/jnci/djn444")),
    _hoisted_106,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_107, "https://www.nejm.org/doi/full/10.1056/NEJMoa073204"))
      : (_openBlock(), _createElementBlock("a", _hoisted_108, "https://www.nejm.org/doi/full/10.1056/NEJMoa073204")),
    _hoisted_109,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_110, "https://journals.lww.com/stdjournal/Fulltext/2009/10000/Acquisition_of_High_Risk_Human_Papillomavirus.4.aspx"))
      : (_openBlock(), _createElementBlock("a", _hoisted_111, "https://journals.lww.com/stdjournal/Fulltext/2009/10000/Acquisition_of_High_Risk_Human_Papillomavirus.4.aspx")),
    _hoisted_112,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_113, "https://www.nature.com/articles/bjc2012489"))
      : (_openBlock(), _createElementBlock("a", _hoisted_114, "https://www.nature.com/articles/bjc2012489")),
    _hoisted_115,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_116, "https://jamanetwork.com/journals/jama/fullarticle/2686793"))
      : (_openBlock(), _createElementBlock("a", _hoisted_117, "https://jamanetwork.com/journals/jama/fullarticle/2686793")),
    _hoisted_118,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_119, "https://pubmed.ncbi.nlm.nih.gov/29181509/"))
      : (_openBlock(), _createElementBlock("a", _hoisted_120, "https://pubmed.ncbi.nlm.nih.gov/29181509/")),
    _hoisted_121,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_122, "https://pubmed.ncbi.nlm.nih.gov/26789267/"))
      : (_openBlock(), _createElementBlock("a", _hoisted_123, "https://pubmed.ncbi.nlm.nih.gov/26789267/")),
    _hoisted_124,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_125, "https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(11)70296-0/fulltext"))
      : (_openBlock(), _createElementBlock("a", _hoisted_126, "https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(11)70296-0/fulltext")),
    _hoisted_127,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_128, "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(13)62218-7/fulltext"))
      : (_openBlock(), _createElementBlock("a", _hoisted_129, "https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(13)62218-7/fulltext")),
    _hoisted_130,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_131, "https://www.epiprev.it/pubblicazione/epidemiol-prev-2012-36-3-4-suppl-1"))
      : (_openBlock(), _createElementBlock("a", _hoisted_132, "https://www.epiprev.it/pubblicazione/epidemiol-prev-2012-36-3-4-suppl-1")),
    _hoisted_133,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_134, "https://academic.oup.com/jnci/article/98/11/765/2521604"))
      : (_openBlock(), _createElementBlock("a", _hoisted_135, "https://academic.oup.com/jnci/article/98/11/765/2521604")),
    _hoisted_136,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_137, "https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(09)70360-2/fulltext"))
      : (_openBlock(), _createElementBlock("a", _hoisted_138, "https://www.thelancet.com/journals/lanonc/article/PIIS1470-2045(09)70360-2/fulltext")),
    _hoisted_139,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_140, "https://www.ejcancer.com/article/S0959-8049(16)32429-7/fulltext"))
      : (_openBlock(), _createElementBlock("a", _hoisted_141, "https://www.ejcancer.com/article/S0959-8049(16)32429-7/fulltext")),
    _hoisted_142,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_143, "https://www.gynecologiconcology-online.net/article/S0090-8258(16)30827-7/fulltext"))
      : (_openBlock(), _createElementBlock("a", _hoisted_144, "https://www.gynecologiconcology-online.net/article/S0090-8258(16)30827-7/fulltext")),
    _hoisted_145,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_146, "http://archive.azcentral.com/ic/pdf/new-england-journal-medicine.pdf"))
      : (_openBlock(), _createElementBlock("a", _hoisted_147, "http://archive.azcentral.com/ic/pdf/new-england-journal-medicine.pdf")),
    _hoisted_148,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_149, "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3156084/"))
      : (_openBlock(), _createElementBlock("a", _hoisted_150, "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3156084/")),
    _hoisted_151,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_152, "https://www.bmj.com/content/335/7629/1077.long"))
      : (_openBlock(), _createElementBlock("a", _hoisted_153, "https://www.bmj.com/content/335/7629/1077.long")),
    _hoisted_154,
    (!_ctx.isMobile())
      ? (_openBlock(), _createElementBlock("a", _hoisted_155, "https://pubmed.ncbi.nlm.nih.gov/28801947/"))
      : (_openBlock(), _createElementBlock("a", _hoisted_156, "https://pubmed.ncbi.nlm.nih.gov/28801947/"))
  ]))
}